import { useState } from "react";
import { addQuote, getQuoteById, getQuotesListByIdFile } from "../../../store/slices/quotes/thunks";
import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import styles from './Quotes.module.css'
import { Quote } from "./Quote";
import { Header } from "../Header/Header";
import { MasterSaleDetails } from "../MasterSale/MasterSaleDetails";
import { setQuote, setQuotesList } from "../../../store/slices/quotes/quotesSlice";
import { getMasterSaleByFile } from "../../../store/slices/files/thunks";

export const Quotes = ({ file }) => {
  const dispatch = useDispatch();
  const { quotesList, quote } = useSelector((state) => state.quotes);
  const { masterSale } = useSelector((state) => state.files);
  const [quoteSelected, setQuoteSelected] = useState("");

  useEffect(() => {
    if (file.id) {
      dispatch(getQuotesListByIdFile(file.id))
    }
    return () => {
      dispatch(setQuotesList([]));
      dispatch(setQuote({}));
    }
  }, [file.id])

  useEffect(() => {
    if (file.id) {
      dispatch(getMasterSaleByFile(file.id))
    }
  }, [file.id])


  useEffect(() => {
    if (quoteSelected) {
      dispatch(getQuoteById(quoteSelected))
    }
  }, [quoteSelected]);

  return (
    <>

      <Header file={file} />

      {
        (masterSale.isOpen === 1 && masterSale.id) && <MasterSaleDetails masterSale={masterSale} file={file} />          
      }

      <button className="btn btn-light btn-icon" style={{ marginTop: 20 }}
        onClick={() => dispatch(addQuote(file.id))} >
        <span>
          <i className="fe fe-plus"></i>&nbsp;
        </span>
        Crear Cotizacion
      </button>

      <div className="d-flex" style={{ marginTop: 20, marginBottom: 20 }} >
        {
          quotesList.map(quote => (
            <button key={quote.id} className={`btn  ${quoteSelected === quote.id ? "btn-info text-white" : "btn-light"}`}
              onClick={() => setQuoteSelected(quote.id)} >
              Cotizacion #{quote.number}
            </button>
          ))
        }
      </div>

      {
        quote.id && <Quote quote={quote} key={quote.id} />
      }

    </>
  )
}
